export const getAnalyticsFiltersTotalCount = (response, dataLength = 0) => {
  const fromHeader = parseFloat(response.headers?.['x-total-count']);
  if (Number.isFinite(fromHeader) && fromHeader >= 0) return fromHeader;

  const fromBody = response.data?.totalElements ?? response.data?.data?.totalElements;
  if (typeof fromBody === 'number' && fromBody >= 0) return fromBody;

  return dataLength;
};
